




















































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import _ from 'lodash';
import { exportToCSV, DatabaseHeader } from './tables/database';

import * as PAPERS_QUERY from 'src/graphql/admin/Papers.graphql';
import * as CREATE_PAPER_QUERY from 'src/graphql/admin/CreatePaper.graphql';
import * as EDIT_PAPER_QUERY from 'src/graphql/admin/EditPaper.graphql';
import * as DELETE_PAPER_QUERY from 'src/graphql/admin/DeletePaper.graphql';

@Component({
  apollo: {
    papers: {
      query: PAPERS_QUERY,
      fetchPolicy: 'cache-and-network',
    },
  }
})
export default class PaperDatabase extends Vue {
  search = '';
  dialog = false;
  deleteDialog = false;
  valid = true;
  savingAs = false;

  requiredRules = [
    v => !!v || 'This field is required',
  ];

  requiredNumberRules = [
    v => typeof(v) == 'number' || 'This field is required',
  ];

  nameRules = [
    v => !!v || 'This field is required',
    v => this.checkUniqueName(v),
  ];

  editedItem = {
    id: -1,
    CEPI_name: "",
    name: "",
    owner: "",
    owner_abbreviation: "",
    source_of_data: "",
    description: "",
    producer: "",
    grammage: 0,
    thickness: 0,
    tensile_stiffness_MD: 0,
    tensile_stiffness_CD: 0,
    tensile_strength_MD: 0,
    tensile_strength_CD: 0,
    compression_strength_MD: 0,
    compression_strength_CD: 0,
    burst: 0,
    CMT: 0,
    time_class: 0,
    RH_class: 0,
    food_safety_factor: 0,
    production_carbon_footprint: 0,
  };

  defaultItem = {
    id: -1,
    CEPI_name: "",
    name: "",
    owner: "",
    owner_abbreviation: "",
    source_of_data: "",
    description: "",
    producer: "",
    grammage: 0,
    thickness: 0,
    tensile_stiffness_MD: 0,
    tensile_stiffness_CD: 0,
    tensile_strength_MD: 0,
    tensile_strength_CD: 0,
    compression_strength_MD: 0,
    compression_strength_CD: 0,
    burst: 0,
    CMT: 0,
    time_class: 0,
    RH_class: 0,
    food_safety_factor: 0,
    production_carbon_footprint: 0,
  };

  headers: DatabaseHeader[] = [
    { text: 'CEPI Name',            value: 'CEPI_name', class: 'fixed-column' },
    { text: 'Name',                 value: 'name', },
    { text: 'Owner',                value: 'owner', },
    { text: 'Owner Abbr.',          value: 'owner_abbreviation' },
    { text: 'Source',               value: 'source_of_data' },
    { text: 'Description',          value: 'description' },
    { text: 'Producer',             value: 'producer' },
    { text: 'Grammage',             value: 'grammage',                    unit: 'kg/m²' },
    { text: 'Thickness',            value: 'thickness',                   unit: 'm' },
    { text: 'Tens. Stiff. MD',      value: 'tensile_stiffness_MD',        unit: 'N/m' },
    { text: 'Tens. Stiff. CD',      value: 'tensile_stiffness_CD',        unit: 'N/m' },
    { text: 'Tens. Str. MD',        value: 'tensile_strength_MD',         unit: 'N/m' },
    { text: 'Tens. Str. CD',        value: 'tensile_strength_CD',         unit: 'N/m' },
    { text: 'Compr. Str. MD',       value: 'compression_strength_MD',     unit: 'N/m' },
    { text: 'Compr. Str. CD',       value: 'compression_strength_CD',     unit: 'N/m' },
    { text: 'Burst',                value: 'burst' ,                      unit: 'Pa' },
    { text: 'CMT',                  value: 'CMT' ,                        unit: 'N' },
    { text: 'Time Class',           value: 'time_class' },
    { text: 'RH Class',             value: 'RH_class' },
    { text: 'Food Safety Factor',   value: 'food_safety_factor' },
    { text: 'Production CO₂',       value: 'production_carbon_footprint', unit: 'kg CO₂/ton' },
  ];

  papers = [];

  editedIndex = -1;

  checkUniqueName(name) {
    if (this.editedIndex != -1 && !this.savingAs)
      return true;

    if (name == null)
      return false;

    const found = this.papers.some( paper => paper.CEPI_name.toLowerCase() === name.toLowerCase() );
    console.log(`Found paper ${name}: ${found}`);
    return !found || 'Paper already exists';
  }

  get formTitle () {
    return this.editedIndex === -1 ? 'New paper' : 'Edit paper';
  }

  editItem(item) {
    this.editedIndex = this.papers.indexOf(item);
    this.editedItem = Object.assign({}, item);

    // Present thickness as mm
    this.editedItem.thickness = Math.round(this.editedItem.thickness * 1000.0 * 10000.0) / 10000.0;

    this.dialog = true;
  }

  close() {
    this.dialog = false;

    setTimeout(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    }, 300)
  }

  save() {
    this.savingAs = false;

    const form = this.$refs.form as any;
    if (!form.validate()) {
      return;
    }

    if (this.editedIndex > -1) {
      this.editPaper();
    } else {
      this.createPaper();
    }

    this.close();
  }

  saveAs() {
    this.savingAs = true;

    const form = this.$refs.form as any;
    const valid = form.validate();

    this.savingAs = false;

    if (!valid) {
      return;
    }

    this.createPaper();
    this.close();
  }

  onExport() {
    exportToCSV('Papers', this.headers, this.papers);
  }

  closeDelete() {
    this.deleteDialog = false;
  }

  deletePaper() {
    this.$apollo.mutate({
      mutation: DELETE_PAPER_QUERY,
      variables: { id: this.editedItem.id },
      update: (store, {data: { deletePaper }}) => {
        let data: any = store.readQuery({
          query: PAPERS_QUERY
        });

        data.papers = data.papers.filter(
          paper => paper.id !== deletePaper
        );

        store.writeQuery({
          query: PAPERS_QUERY,
          data
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        deletePaper: this.editedItem.id,
      },
    });

    this.closeDelete();
    this.close();
  }

  cloneInput(omit) {
    let input = _.omit(this.editedItem, omit);

    // Save thickness as m
    input.thickness = input.thickness / 1000.0;

    return input;
  }

  createPaper() {
    const input = this.cloneInput(['__typename', 'id']);

    this.$apollo.mutate({
      mutation: CREATE_PAPER_QUERY,
      variables: { input },
      update: (store, {data: { createPaper }}) => {
        let data: any = store.readQuery({
          query: PAPERS_QUERY
        });

        data.papers.push(createPaper);

        store.writeQuery({
          query: PAPERS_QUERY,
          data
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        createPaper: {
          __typename: 'Paper',
          id: -1,
          ...input,
        },
      },
    });
  }

  editPaper() {
    const input = this.cloneInput(['__typename']);

    this.$apollo.mutate({
      mutation: EDIT_PAPER_QUERY,
      variables: { input },
      update: (store, {data: { editPaper }}) => {
        let data: any = store.readQuery({
          query: PAPERS_QUERY
        });

        data.papers = data.papers.filter(
          paper => paper.id !== this.editedItem.id
        );

        data.papers.push(editPaper);

        store.writeQuery({
          query: PAPERS_QUERY,
          data,
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        editPaper: {
          __typename: 'Paper',
          ...input,
        },
      },
    });
  }

  @Watch('dialog')
  onDialogChange(val) {
    if (!val)
      this.close();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin/PaperDatabase.vue